import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on pathname change.
 * Skips when a hash is present so anchor navigation keeps working.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
